/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterPrice_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuPriceRanges_itemSearch" | "SbSharedRefineMenuInputRangeCurrency_itemSearch" | "SbSharedRefineMenuSaleInput_itemSearch">;
    readonly " $refType": "SbRespRefineMenuFilterPrice_itemSearch";
};
export type SbRespRefineMenuFilterPrice_itemSearch$data = SbRespRefineMenuFilterPrice_itemSearch;
export type SbRespRefineMenuFilterPrice_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuFilterPrice_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterPrice_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterPrice_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuPriceRanges_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeCurrency_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuSaleInput_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '0c6e200de97b0b14bb8a1d33b2d35f80';
export default node;
